import React from 'react';
import sessionTypesQuery from 'ApolloClient/Queries/sessionTypes';
import createSessionType from 'ApolloClient/Mutations/createSessionType';
import { graphql } from 'react-apollo';
//
import SessionTypeForm from 'components/forms/SessionTypeForm';

export class CreateSessionType extends React.PureComponent {
  state = {
    loading: false,
  };

  onSubmitHook = params => {
    this.setState({ loading: true });

    let variables = {
      params,
    };
    let refetchQueries = [{ query: sessionTypesQuery, variables: {} }];
    // let update = (cache, { data: { addTodo } }) => {
    //     const cacheData = cache.readQuery({ query: GET_USER_DATA });
    //     console.log(cacheData.user.organization)
    // }
    this.props
      .createSessionType({ variables, refetchQueries })
      .then(res => {
        this.setState({ loading: false });
        this.props.toggleModal();
        // window.location.reload();
      })
      .catch(err => {
        this.setState({ loading: false });
        console.log(err);
      });
  };

  render() {
    return (
      <div>
        <SessionTypeForm onSubmitHook={this.onSubmitHook} loading={this.state.loading} />
      </div>
    );
  }
}

export default graphql(createSessionType, { name: 'createSessionType' })(CreateSessionType);



// WEBPACK FOOTER //
// ./src/routes/app-studio/SessionTypesArea/CreateSessionType/index.js